var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',[_c('h5',{staticClass:"mt-3 mb-4 text-left institution-title"},[_vm._v(_vm._s(_vm.user.institution.name))]),_c('b-row',[_c('statistic-number',{attrs:{"institution":_vm.user.institution}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }